document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");

  // Delegación de eventos para clic en <summary>
  document.body.addEventListener("click", function (e) {
    const summaryClicked = e.target.closest("summary");
    if (summaryClicked && summaryClicked.closest("header nav")) {
      header.classList.add("force-white");
    }
  });

  // Detectar cuando se cierra cualquier <details> del nav
  const navDetails = document.querySelectorAll("header nav details");

  navDetails.forEach(details => {
    details.addEventListener("toggle", function () {
      if (!details.open) {
        // Si TODOS los <details> están cerrados, quitamos la clase
        const stillOpen = Array.from(navDetails).some(d => d.open);
        if (!stillOpen) {
          header.classList.remove("force-white");
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header");
  const mobileMenu = document.querySelector("details");

  if (mobileMenu) {
    // Observar cambios en atributos
    const observer = new MutationObserver(() => {
      if (mobileMenu.classList.contains("menu-opening")) {
        header.classList.add("force-white");
      } else {
        header.classList.remove("force-white");
      }
    });

    observer.observe(mobileMenu, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }
});